import React, { useEffect, useState } from 'react'
import { ExamcompassClient } from '../Api/api';
import Loading from '../UI/Loading'


const Term:React.FC = () => {
  const [terms, setTerms] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  
  useEffect(() => {
    const fetchTerms = async() => {
      try {
        setIsLoading(true)
        const response = await ExamcompassClient.get('/info/terms_page/');
        setTerms(response?.data.note)
      }
      catch (err) {
        console.log('Error fetching terms and condition');
      }
      finally {
        setIsLoading(false)
      }
    }
    
    fetchTerms();
  }, [])

  if (isLoading) {
    return (
      <div className='w-full h-[100vh] flex items-center justify-center'>
        <Loading />
      </div>
    )
  }

  return (
    <section>
      <div className='w-full h-[300px] bg-gradient-to-tr from-darkGreen to-lemonGreen pt-14 flex items-center justify-center'>
        <p className='text-[40px] font-extrabold text-white'>Terms And Condition</p>
      </div>
      <div className='container w-[80%] py-12' dangerouslySetInnerHTML={{ __html: terms}}></div>
    </section>
  )
}

export default Term